import React, { useState, useEffect } from 'react';
import topUpfailedImg from "../../assets/img/failure_icn.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import StorefrontTitle from "../shared/storefront-title.component";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import User from "../../services/user.service";
import Storage from "../../services/storage.service";
import checkModule from '../shared/checkModule';
import FirebaseAnalytics from '../../services/analytics.service';

const subscriptions = [];
const TopUpFailed = (props) => {

  const prefix = "scr_3.3.3";
  const appDownloadInfo = Translation.keys[prefix + "_app_download_info"];
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    Storage.set("topPaymentFailed", true, true);
    setLoader(true);
    Storage.get_obsrv("paymentErrormsg").subscribe(data => {
      setErrorMsg(data);
    });
    const firebase_event_params = {
      event_category: 'quick_top_up',
      event_screen: 'quick_top_up_error',
      interaction_type: 'view',
      event_label: 'error',
      error_code: Storage.get("paymentErrorCode", true) || '',
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);

    setLoader(false);
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }

  }, []);

  const topUpAgain = () => {
    Storage.clear("calledFeatureConfirmation");
    Storage.clear("confirmSuccess");
    Storage.clear("confirmFailed");
    setLoader(true);
    const firebase_event_params = {
      event_category: 'quick_top_up',
      event_screen: 'quick_top_up_error',
      interaction_type: 'click',
      event_label: 'try_again',
      // attempts: []
    }
    FirebaseAnalytics.commonFunction(firebase_event_params);

    Storage.clear("topPaymentFailed");
    User.fetchFlowStatus().then(() => {
      setLoader(false);
      window.location.href = "/join/#/topup-pay/";
    }).catch(() => {
      setLoader(false);
      Storage.clear("topPaymentFailed");
      window.location.reload();
    });
  }

  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
        <div className="stm-topup-info-container">
          <div className="success-img">
            <img src={topUpfailedImg} alt="" />
          </div>
          <StorefrontTitle
            title={Translation.keys[prefix + "_title_failed"]}
            desc={Translation.keys[prefix + "_subtitle_failed"]}
          />

          <div className="topup-field-wrapper">
            <p className="topup-error-msg">
              {errorMsg}
            </p>
            <div className="topup-btn-section">
              <button
                className="storefront-button"
                type="button"
                onClick={() => { topUpAgain() }}
              >
                {Translation.keys[prefix + "_try_again"]}
              </button>
            </div>
          </div>
          {
            checkModule.isTopUpKw ?
              <DownloadApps
                info={appDownloadInfo}
                classes={"download-apps"}
                google_play_link={Settings.ob_google_play}
                app_store_link={Settings.ob_app_store}
                huawei_store_link={Settings.ob_app_gallery}
              /> : null}

          {checkModule.isTopUpKsa ?
            <DownloadApps
              info={appDownloadInfo}
              classes={"download-apps"}
              google_play_link={Settings.google_play_link}
              app_store_link={Settings.app_store_link}
              huawei_store_link={Settings.huawei_store_link}
            /> : null}
        </div>
      }
    </>
  );
};

export default TopUpFailed;